const STANDSTILL_REASONS = {
  STANDSTILL: '',
  STANDSTILL_TRUCKS_QUEUE: 'En cola',
  STANDSTILL_GOODS_NOT_AVAILABLE: 'Mercancía no disponible',
  STANDSTILL_BAD_REFERENCE: 'Mala referencia',
  STANDSTILL_CLOSED_WAREHOUSE: 'Almacén cerrado',
  STANDSTILL_MISSING_PLATES: 'Matrículas desaparecidas',
  STANDSTILL_SLOW_LOADING: 'Carga/Descarga lenta',
  STANDSTILL_OTHER: 'Otro motivo',
  REASON_OTHER: 'Otro motivo',
};

export const UNLOCK_FOR_AGENTS_REASONS = {
  COMPLEX_DUE_TO_SPECIFICATIONS_ORDER: 'El pedido es demasiado complejo (altura, peso, etc.)',
  CONTRACT_OR_RECURRENT_ORDER: 'El pedido forma parte de un contrato/recurrente',
  FOR_SERVICE_FLEET_ORDER: 'Necesito esta orden para alimentar mi flota',
  NON_ROUTABLE_ORDER: 'El pedido no es enrutable',
  COMPLICATED_LOCATION_ORDER: 'Lugares de recogida o entrega complicados',
  CUSTOMER_PRIVILEGE_ORDER: 'Tengo que atender a este cliente',
  // IS_CODI: 'Is CoDi',
  MOVED_BY_RESCUER: 'Moved automatically by Rescuer',
  IS_URGENT: 'Time for pickupis near',
  // IS_XDOCK: 'Is X-Dock order',
  REASON_OTHER: 'Other reason',
};

export const UNLOCK_JOURNEY_FOR_AGENTS_REASONS = {
  SPECIFIC_DRIVER_ASSIGNMENT: 'Necesito asignar un conductor específico',
  CREATE_OWN_ROUTE: 'Necesito esta orden para hacer mi propia ruta',
  BAD_ROUTE: 'Esta ruta no es buena',
  NON_ROUTABLE_ORDER: 'El pedido no es enrutable',
  MOVED_BY_RESCUER: 'Moved automatically by Rescuer',
  BASE_COST_IS_WRONG: 'El coste base es incorrecto',
  ADD_EXTRA_COST: 'Necesito añadir un coste adicional',
  // IS_CODI: 'Is CoDi',
  REASON_OTHER: 'Other reason',
};

export const REJECTION_ITINERARY_FEEDBACK_REASONS = {
  MARGIN_TOO_LOW: 'Margen demasiado bajo',
  DISTANCE_TOO_LONG: 'La distancia es demasiado larga',
  SCHEDULED_TIME_TOO_TIGHT: 'El calendario es demasiado justo',
  RUNNING_EMPTY_KM_FOR_TOO_LONG: 'Demasiado tiempo en vacío',
  ROUTE_HAS_NO_RETURN: 'La ruta no tiene retorno',
  ROUTE_STARTS_OR_STOPS_IN_REMOTE_AREA: 'La ruta comienza y termina en una zona remota',
  OTHER_REASON: 'Otro motivo',
};

export const JOURNEY_LAUNCHED_TO_POOL_REASONS = {
  CLOSE_TO_START: 'Cerca de la hora de recogida',
  LOW_ROUTING_PROBABILITY: 'Baja probabilidad de enrutamiento',
  TIME_TO_LAUNCH_AUTOMATIC_BY_VEHICLE_TYPE: 'Scheduled launch due to vehicle type', //not used anymore
  TIME_TO_LAUNCH_TYCOON: 'Scheduled launch',
  TIME_TO_LAUNCH_TYCOON_MARGIN: 'Scheduled launch due to margin',
  BIDDING_ENABLED: 'Launched to enable bidding',
  DAILY_RELAUNCH: 'Daily relaunch',
  TIME_TO_LAUNCH_SAFE_NET: 'Safe net scheduled launch (after working hours)',
  SHIPPER_CANCELS_EARLY: 'Shipper is unlikely to cancel',
  REASON_OTHER: 'Other reason', //not used anymore
};

export const SCAN_SKIPPED_REASONS = {
  DECIDED_BY_DRIVER: 'Decided by driver',
};

const logTexts = {
  action_names: {
    ASSIGN_DRIVER: 'Conductor asignado manualmente',
    DELETE_CARGO_MANIFEST: 'Albarán eliminado',
    CHANGE_JOURNEY_STATUS: 'Estado modificado',
    CANCEL_SHIPPER_ORDER: 'Pedido anulado',
    UNASSIGN_DRIVER: 'Conductor no asignado manualmente',
    UPDATE_SHIPPER_ORDER: 'Pedido editado',
    EDIT_SHIPPER_ORDER_BY_SHIPPER: 'Orden editada por el cliente',
    CREATE_SHIPPER_ORDER: 'Orden creada',
    UPDATE_PRICE: 'El precio ha cambiado',
    UPDATE_PRICE_BY_STANDSTILL: 'Paralización a cargo del cargador',
    UPDATE_PRICE_BY_INCIDENT: 'Cambio de precio debido a un incidente',
    UPLOAD_CARGO_MANIFEST: 'Albarán cargado',
    ACTION_MANUAL_BILLING: 'Facturación manual verificada',
    UPDATE_PENALTY: 'Penalización de costes',
    UPDATE_COST_INCREMENT: 'Aumento de los costes',
    UPDATE_BONUS: 'Bonificación añadida',
    ZENDESK_STANDSTILL_PICKUP: 'Paralización en la recogida',
    ZENDESK_STANDSTILL_DROPOFF: 'Paralización en descarga',
    ACTION_OTHER: 'Registro manual',
    STANDSTILL_PICKUP_WARNING_TO_SHIPPER:
      'Un conductor advierte de la paralización de una recogida',
    STANDSTILL_DROPOFF_WARNING_TO_SHIPPER:
      'Un conductor advierte de la paralización de una descarga',
    UNASSIGNED_BY_DRIVER: 'El conductor abandonó el trabajo',
    ACCEPTED_OFFER_BY_DRIVER: 'El conductor aceptó el trabajo',
    JOURNEY_LAUNCHED_TO_POOL: 'Publicado en la app ',
    JOURNEY_CREATED_FROM_ITINERARY: 'Trabajo creado',
    AUTOMATIC_COST_INCREMENT_APPLIED: 'Cost incremented automatically',
    AUTOMATIC_PENALTY_APPLIED: 'Penalty applied automatically',
    UNLOCK_FOR_AGENTS: 'Orden pasada a manual',
    UNLOCK_JOURNEY_FOR_AGENTS: 'Set job to manual',
    TASK_CREATED_MANUALLY: 'Task created manually',
    TASK_CREATED_AUTOMATICALLY: 'Task created automatically',
    TASK_CREATED_DRIVER: 'Task created by Driver',
    TASK_CREATED_XDOCK: 'Task created by xDock',
    TASK_SOLVED_MANUALLY: 'Task solved manually',
    TASK_SOLVED_AUTOMATICALLY: 'Task solved automatically',
    TASK_ASSIGNED_TO_NEW_OWNER: 'Task assigned to new owner',
    TASK_UNASSIGNED_OWNER_UNAVAILABLE: 'Job moved to No owner due to unavailable agent',
    TASK_REVIEWED: 'Task reviewed',
    TASK_UPDATED: 'Task updated',
    TASK_SCHEDULED_MANUALLY: 'Task scheduled manually',
    TASK_SCHEDULED_AUTOMATICALLY: 'Task scheduled automatically',
    TASK_TO_PENDING_REVIEW: 'Task moved back to be reviewed',
    CARRIER_CALLED_THE_WAREHOUSE: 'Carrier called the warehouse',
    EMAIL_OFFER_SENT: 'Oferta enviada por correo electrónico',
    DRIVER_ASSIGNED_AUTOMATICALLY: 'Driver assigned automatically',
    BID_OFFER_BY_DRIVER: 'Driver bid the job',
    SO_RETURN_CREATED: 'Return order created',
    JOURNEY_FROZEN_MANUALLY: 'Journey frozen manually',
    JOURNEY_FROZEN_AUTOMATICALLY: 'Journey frozen automatically',
    UNABLE_TO_FREEZE_AUTOMATICALLY: 'Unable to freeze automaticaly',
    CHAT_TASK_SOLVED: 'Task solved automatically',
    CHAT_TASK_CREATED: 'Task created automatically',
    SHIPPER_ORDER_BROKEN: 'Pedido retirado del trabajo',
    JOURNEY_BROKEN: 'Job broken',
    XDOCK_AUXILIARY_ORDERS_CREATED: 'Create x-Dock orders',
    SEND_DOCUMENTATION_TO_DRIVER: 'Documentation sent to driver',
    TRACKING_START: 'Journey tracked with Project44',
    ORDER_PDF_DOWNLOADED: 'El transportista ha descargado el PDF del pedido',
    CSA_JOURNEY_OWNERSHIP: 'Journey ownership set automatically',
    DRIVER_NOT_ASSIGNED_YET: 'Email warning sent to Shipper: "No driver assigned yet"',
    EMAIL_TO_SHIPPER_SENT: '"Possible delay" email sent',
    POSSIBLE_EMAIL_TO_SHIPPER: '"Possible delay" email planned',
    SCAN_SKIPPED: 'Scan skipped',
    LOAD_SCANNED: 'Load scanned',
    LOAD_SCANNED_MISSING: 'Missing pallets while scanning',
    APPOINTMENT_BOOKED: 'Appointment Booked',
    ACCEPTED_OFFER_IMPROVEMENT_BY_DRIVER: 'Driver accepted the job improvement',
    REJECTED_OFFER_IMPROVEMENT_BY_DRIVER: 'Driver rejected the job improvement',
    JOURNEY_STOP_TIME_UPDATED: 'Time window at crossdock edited',
    CHAT_SENT_AUTOMATICALLY: 'Chat sent automatically',
    CHANGE_CROSS_DOCK_DECISIONS: 'Cross-docks changed',
    JOURNEY_UPGRADED: 'Journey upgraded',
    PORTIC_BCN_PICKUP_NOTICE_ERROR: 'Error en preaviso de Recogida/Entrega de Mercancia',
    PORTIC_BCN_DROPOFF_NOTICE_ERROR: 'Error en preaviso de Recogida/Entrega de Mercancía',
    PORTIC_BCN_PICKUP_NOTICE_SUCCESS: 'Preaviso de Recogida de Mercancía satisfactorio',
    PORTIC_BCN_DROPOFF_NOTICE_SUCCESS: 'Preaviso de Entrega de Mercancía satisfactorio',
    PORTIC_BCN_PICKUP_NOTICE_UNANSWERED:
      'Preaviso de Recogida de Mercancía entregado sin respuesta',
    PORTIC_BCN_DROPOFF_NOTICE_UNANSWERED:
      'Preaviso de Entrega de Mercancía entregado sin respuesta',
  },
  titles: {
    ASSIGN_DRIVER: '¿Por qué asignó al conductor?',
    DELETE_CARGO_MANIFEST: '¿Por qué ha borrado este albarán?',
    CHANGE_JOURNEY_STATUS: '¿Por qué ha actualizado el estado?',
    CANCEL_SHIPPER_ORDER: '¿Por qué ha cancelado este pedido?',
    UNASSIGN_DRIVER: '¿Por qué has desasignado al conductor?',
    UPDATE_SHIPPER_ORDER: '¿Por qué ha editado este pedido?',
    EDIT_SHIPPER_ORDER_BY_SHIPPER: '¿Por qué ha editado este pedido?',
    CREATE_SHIPPER_ORDER: '¿Por qué ha creado este pedido?',
    UPDATE_PRICE: '¿Por qué ha cambiado el precio?',
    UPDATE_PRICE_BY_INCIDENT: 'Has añadido un extra a causa de un incidente',
    UPLOAD_CARGO_MANIFEST: '¿Por qué ha subido este albarán?',
    ACTION_MANUAL_BILLING: '¿Por qué ha comprobado la facturación manual?',
    UPDATE_COST_INCREMENT: '¿Por qué ha cambiado el coste?',
    UPDATE_PENALTY: '¿Por qué ha cambiado el coste?',
    ACTION_OTHER: 'Registro manual',
  },
  reasons: {
    ASSIGN_DRIVER: {
      SPECIFIC_DRIVER: 'Queremos que lo haga un conductor concreto',
      NOT_ACCEPTED_AUTOMATICALLY: 'No se acepta automáticamente',
      REASON_OTHER: 'Otro motivo',
    },
    DELETE_CARGO_MANIFEST: {
      WRONG_PICTURE: 'El documento no es un albarán válido',
      BAD_PICTURE: 'El texto no es claramente visible',
      BAD_FORMAT: 'El documento no tiene el formato solicitado por el expedidor',
      WRONG_STOP: 'El documento está en la parada equivocada',
      MISSING_PAGES: 'Al documento le faltan páginas',
      INCOMPLETE: 'Al documento le falta el sello o la firma',
      MISSING_BL: 'Faltan documentos adicionales (BL)',
      REASON_OTHER: 'Otro motivo',
    },
    CHANGE_JOURNEY_STATUS: {
      DRIVER_CANNOT_DO: 'El conductor no puede hacerlo',
      DRIVER_FORGET: 'El conductor se ha olvidado de hacerlo',
      REASON_OTHER: 'Otro motivo',
    },
    CANCEL_SHIPPER_ORDER: {
      REQUESTED_BY_SHIPPER: 'Solicitado por el cliente (excepto duplicado)',
      LOAD_NOT_READY: 'La carga no está lista',
      DRIVER_LATE_FOR_PICKUP: 'El conductor llega tarde a la recogida',
      DRIVER_NOT_FOUND: 'No se ha encontrado ningún conductor',
      DUPLICATED_ORDER: 'Pedido duplicado',
      LOAD_IS_NOT_WHAT_SHIPPER_SAID: 'La carga no es lo que el cliente nos dijo',
      EXCEPTION_IN_RECURRING_ORDER: 'Excepción en una orden recurrente',
      REASON_OTHER: 'Otro motivo',
      SO_TOO_LONG_ASSIGNATION: 'Demasiado tiempo para asignar',
      SO_I_DONT_NEED_IT_OR_CANT_DO_IT: 'Ya no lo necesito',
    },
    UNASSIGN_DRIVER: {
      DRIVER_CANNOT_DO: 'El conductor no puede hacer el trabajo',
      VEHICLE_NOT_VALID: 'El vehículo no es adecuado para el trabajo',
      ROUTE_WRONG_PLANNIFIED: 'Badly planned / complex route',
      CARRIER_IS_UNWILLING: 'El conductor no quiere hacer el trabajo',
      CARRIER_IS_UNABLE: 'El conductor no puede hacer el trabajo',
      SYSTEM_MISMATCH: 'Our decision',
      REASON_OTHER: 'Otro motivo',
    },
    UPDATE_SHIPPER_ORDER: {
      SHIPPER_ORDER_CHANGED: 'El orden ha cambiado',
      SHIPPER_ORDER_WRONG: 'Faltaba información o era incorrecta',
      REASON_OTHER: 'Otro motivo',
    },
    CREATE_SHIPPER_ORDER: {
      SHIPPER_LAZY: 'El cargador es impresionante',
      SHIPPER_FIRST_TIME: 'Es la primera vez que el cargador',
      AREA_UNAVAILABLE: 'No se admiten envíos con este código postal / zona',
      REASON_OTHER: 'Otro motivo',
    },
    UPDATE_PRICE: {
      NOT_ACCEPTED_AUTOMATICALLY: 'Ningún conductor acepta el pedido',
      GROUPAGE: 'Groupage (to create profit)',
      REASON_OTHER: 'Otro motivo',
    },
    UPDATE_PRICE_BY_STANDSTILL: {
      REASON_OTHER: 'Otro motivo',
    },
    UPDATE_PRICE_BY_INCIDENT: {
      REASON_OTHER: 'Otro motivo',
    },
    UPLOAD_CARGO_MANIFEST: {
      APP_FAILED: 'App crash',
      DRIVER_LAZY: 'Driver is a bum',
      REASON_OTHER: 'Otro motivo',
    },
    ACTION_MANUAL_BILLING: {
      REASON_OTHER: 'Otro motivo',
    },
    UPDATE_COST_INCREMENT: {
      SHIPPER_ORDER_OF_RECURRING_ORDER_EDITED:
        'Se ha editado una orden de remitente de un pedido recurrente',
      AGREEMENT_SHIPPER: 'Tenemos un acuerdo con el cliente',
      AGREEMENT_CARRIER: 'Tenemos un acuerdo con el transportista',
      CORNER_CASE: 'Es un caso esquinado',
      CARRIER_NEGOCIATED_COST: 'El transportista ha negociado el coste',
      JOURNEY_NOT_ASSIGNED_BY_ITSELF: 'La orden no se asigna por sí sola',
      REASON_OTHER: 'Otro motivo',
    },
    ACTION_OTHER: {
      SUPPORT: 'Hemos prestado apoyo',
      DOCUMENTATION: 'Documentación',
      REASON_OTHER: 'Otro motivo',
    },
    DRIVER_NOT_ASSIGNED_YET: {
      DRIVER_NOT_FOUND: 'Conductor no encontrado',
      REASON_OTHER: 'Otro motivo',
    },
    AUTOCANCEL_SHIPPER_ORDER: {
      DRIVER_NOT_FOUND: 'Conductor no encontrado',
      REASON_OTHER: 'Otro motivo',
    },
    STANDSTILL_PICKUP_WARNING_TO_SHIPPER: {
      ...STANDSTILL_REASONS,
    },
    STANDSTILL_DROPOFF_WARNING_TO_SHIPPER: {
      ...STANDSTILL_REASONS,
    },
    TASK_CREATED_AUTOMATICALLY: {
      REASON_OTHER: '',
      DELAY_RISK: 'Orden con riesgo de retraso',
    },
    ZENDESK_STANDSTILL_PICKUP: {
      ...STANDSTILL_REASONS,
    },
    ZENDESK_STANDSTILL_DROPOFF: {
      ...STANDSTILL_REASONS,
    },
    UNLOCK_FOR_AGENTS: {
      ...UNLOCK_FOR_AGENTS_REASONS,
      ...UNLOCK_JOURNEY_FOR_AGENTS_REASONS,
    },
    UNLOCK_JOURNEY_FOR_AGENTS: {
      ...UNLOCK_FOR_AGENTS_REASONS,
      ...UNLOCK_JOURNEY_FOR_AGENTS_REASONS,
    },
    CARRIER_CALLED_THE_WAREHOUSE: {
      CLOSED_WAREHOUSE: 'El almacén parece cerrado',
      CANT_FIND_WAREHOUSE: 'No encuentro el almacén',
    },
    AUTOMATIC_COST_INCREMENT_APPLIED: {
      COST_ADJUSTMENT: 'Coste ajustado a tanto alzado',
      COST_ADJUSTMENT_FOR_SELECTED_BID: 'Cost adjusted to bid assignation',
      COST_ADJUSTMENT_FOR_OFFERED_JOURNEY: 'Coste ajustado al importe original del viaje',
    },
    AUTOMATIC_PENALTY_APPLIED: {
      COST_ADJUSTMENT: 'Coste ajustado a tanto alzado',
      COST_ADJUSTMENT_FOR_SELECTED_BID: 'Cost adjusted to accepted bid',
      COST_ADJUSTMENT_FOR_OFFERED_JOURNEY: 'Coste ajustado al importe original del viaje',
    },
    TASK_SCHEDULED_MANUALLY: {
      WITH_TIMER: 'With timer',
    },
    TASK_SCHEDULED_AUTOMATICALLY: {
      WITH_TIMER: 'With timer',
    },
    CHAT_TASK_SOLVED: {
      CHAT: 'Chat',
    },
    CHAT_TASK_CREATED: {
      CHAT: 'Chat',
    },
    JOURNEY_BROKEN: {
      SHIPPER_ORDER_BROKEN_NO_REASON: 'Pedido retirado',
    },
    SHIPPER_ORDER_BROKEN: {
      SHIPPER_ORDER_BROKEN_BY_LAUNCH: 'Lanzar',
      SHIPPER_ORDER_BROKEN_BY_RELEASE: 'Publicar',
      SHIPPER_ORDER_BROKEN_BY_ASSIGN: 'Asignar',
    },
    SEND_DOCUMENTATION_TO_DRIVER: {
      DOCUMENTATION: '',
    },
    JOURNEY_LAUNCHED_TO_POOL: {
      ...JOURNEY_LAUNCHED_TO_POOL_REASONS,
    },
    SCAN_SKIPPED: {
      ...SCAN_SKIPPED_REASONS,
    },
  },
};

export default logTexts;
